import { getNiceDate, reverseMap, smashObjects, timestampToMS } from '@iotv/datamodel-core';
import { isPayloadMessageType } from '@iotv/iotv-v3-types';
import { AxisId, FeatureId } from './types';
const debug = process.env.REACT_APP_DEBUG && false;
const AxidIdRev = reverseMap(AxisId);
const FeatureIdRev = reverseMap(FeatureId);
/**
 * This is what happens when it is not acceptable just to flatten an object. Ho hum.
 */
export const flattenDeviceMessages = (deviceMessages) => deviceMessages?.map((message) => {
    let flatteded = {};
    if (isPayloadMessageType(message)) {
        const v015UplinkMessage = message;
        const reported = v015UplinkMessage.state.reported;
        const { activityReport, conditionReport, alertReport, batteryVoltage, diagnosticModeReport, error, gpsFixConfig, gpsFixStdDev, meta, mlcTreeMeasureType, position, status, xlEmbeddedMemoryValues, } = reported;
        const { deviceId, accountId, customerDeviceId, deviceEui, deviceName, deviceType, messageId, projectCode, systemStage, timestamp } = meta ?? {};
        const { positionAgeYoung, uplinkSizeLow, downlinkConfigError, batteryChargeStatus, reboot, downlinkAck } = status ?? {};
        const { batteryErr, linkCheckErr } = error ?? {};
        const { cantering, cast, charging, gpsKeepalive, lipcurl, lying, move_av_vel, move_curr_vel, move_max_vel, movement, rearing, standing, steps, trotting, walking, } = activityReport ?? {};
        const { charging: chardgin_condition, chewing, devTemp, eating, flankWatching, hsTemp, ir_amb_temp, rolling, teethGrinding, xl_temp, } = conditionReport ?? {};
        const { alertRolling, foaling } = alertReport ?? {};
        const { DOP, age, heading, lat, lng, speed, elevation } = position ?? {};
        const { activityXLRule, averagingSetSize, coldTimeout, gpsRatePeriod, maxDoP, skipCount, warmTimeout } = gpsFixConfig ?? {};
        const { gpsAllFixesCount, gpsDopStd, gpsFixAvDuration, gpsHeadingStd, gpsLatitudeStd, gpsLongitudeStd, gpsRunningFixAvCount, gpsSpeedStd } = gpsFixStdDev ?? {};
        const { nodeBranching, nodeFeatureMetaClass, nodeValueThreshold, treeNodeCount, treeNumber } = mlcTreeMeasureType ?? {};
        const { address, page, value } = xlEmbeddedMemoryValues ?? {};
        const { fCnt, wCnt, windowFeatureVals } = diagnosticModeReport ?? {};
        flatteded = {
            deviceId,
            accountId,
            customerDeviceId,
            deviceEui,
            deviceName,
            deviceType,
            messageId,
            projectCode,
            systemStage,
            timestamp,
            positionAgeYoung,
            uplinkSizeLow,
            downlinkConfigError,
            batteryChargeStatus,
            reboot,
            downlinkAck,
            batteryErr,
            linkCheckErr,
            cantering,
            cast,
            charging,
            gpsKeepalive,
            lipcurl,
            lying,
            move_av_vel,
            move_curr_vel,
            move_max_vel,
            movement,
            rearing,
            standing,
            steps,
            trotting,
            walking,
            chardgin_condition,
            chewing,
            devTemp,
            eating,
            flankWatching,
            hsTemp,
            ir_amb_temp,
            rolling,
            teethGrinding,
            xl_temp,
            alertRolling,
            foaling,
            DOP,
            age,
            heading,
            lat,
            lng,
            speed,
            elevation,
            activityXLRule,
            averagingSetSize,
            coldTimeout,
            gpsRatePeriod,
            maxDoP,
            skipCount,
            warmTimeout,
            gpsAllFixesCount,
            gpsDopStd,
            gpsFixAvDuration,
            gpsHeadingStd,
            gpsLatitudeStd,
            gpsLongitudeStd,
            gpsRunningFixAvCount,
            gpsSpeedStd,
        };
    }
    return flatteded;
});
const deviceControlMessageIsDiagnosticModeResultType = (m) => {
    const c = m;
    if (!c) {
        console.log(`WARN: deviceControlMessageIsDiagnosticModeResultType got undefined`);
    }
    return c && !!(c.fCnt && c.wCnt && c.windowFeatureVals);
};
export const extractDiagnosticMessages = (deviceControlMessages) => {
    debug && console.log('extractDiagnosticMessages', deviceControlMessages);
    return deviceControlMessages
        ?.map((message) => {
        const { diagnosticModeReport, meta: { deviceEui, timestamp }, } = message;
        let flatteded = {
            diagnosticModeReport,
            deviceId: deviceEui,
            timestamp,
        };
        return flatteded;
    })
        .filter((item) => item?.diagnosticModeReport !== undefined);
};
export const sortAndConvertByTimestamp = (timestampObs) => timestampObs
    .sort((a, b) => (a.timestamp ?? 0) - (b.timestamp ?? 0))
    .reverse()
    .map((item) => ({ ...item, timestamp: item.timestamp ? getNiceDate(timestampToMS(item.timestamp) ?? 0) : undefined })) ?? [];
const inferTimestamp = ({ timeslots, windowIdx, lastTimestamp, thisTimestamp }) => lastTimestamp + (thisTimestamp - lastTimestamp) * ((windowIdx + 1) / timeslots); //placeholder!!!
export const transformDiagnosticModeReport = ({ diagnosticMessage, downlinkXlSetTree, lastTimestamp, }) => {
    const { timestamp, diagnosticModeReport } = diagnosticMessage;
    const requestedNodeConfigs = downlinkXlSetTree.nodeConfigs;
    debug && console.log('transformDiagnosticModeReport', { diagnosticMessage, requestedNodeConfigs });
    const diagnosticValues = [];
    const timeslots = diagnosticModeReport?.windowFeatureVals?.length ?? 0;
    diagnosticModeReport?.windowFeatureVals.forEach((wfVal, windowIdx) => {
        wfVal.forEach((value, featureIdx) => {
            const requestedNodeConfig = requestedNodeConfigs[featureIdx];
            if (requestedNodeConfig) {
                const { featureId, axisId } = requestedNodeConfig;
                const featureAxis = FeatureAxisTOfeatureAxisStr({ featureId, axisId });
                if (featureAxis && timestamp) {
                    const diagnosticValue = {
                        timestamp: inferTimestamp({ lastTimestamp, thisTimestamp: timestamp, windowIdx, timeslots }),
                        type: 'TimeSeriesRecord',
                        featureAxis,
                        value,
                    };
                    diagnosticValues.push(diagnosticValue);
                }
                else {
                    debug && console.log('no featureAxis for', { featureId, axisId });
                }
            }
            else {
                debug && console.log(`No requestedNodeConfig for featureIdz ${featureIdx}`, { requestedNodeConfigs });
            }
        });
    });
    return diagnosticValues;
};
export const flatDiagnosticRecordsToTimestampedMultipleFARecords = (flatRecords) => {
    const timestampedMultipleFARecords = {};
    flatRecords.forEach((item) => {
        if (!timestampedMultipleFARecords[item.timestamp]) {
            timestampedMultipleFARecords[item.timestamp] = { timestamp: item.timestamp };
        }
        Object.assign(timestampedMultipleFARecords[item.timestamp], { [item.featureAxis]: item.value });
    });
    return timestampedMultipleFARecords;
};
export const objectToChartProps = (title, objects) => {
    let chartProps = undefined;
    objects = objects.filter((object) => typeof object.timestamp === 'number');
    const keys = Object.keys(smashObjects(objects));
    if (objects.length > 0 && keys.length > 1) {
        chartProps = {
            data: new google.visualization.DataTable(),
            options: {
                height: 300,
                width: 1200,
                title: title,
                id: 'x',
            },
            name: 'xy',
        };
        const columns = [['datetime', 'Time'], ...keys.filter((k) => k !== 'timestamp').map((k) => ['number', k])]; // x
        columns.forEach((col) => chartProps.data.addColumn(col[0], col[1]));
        objects.forEach((ob, i) => {
            const row = keys
                .filter((k) => k !== 'timestamp')
                .map((k) => {
                let x = null;
                if (typeof ob[k] === 'number') {
                    x = ob[k];
                }
                return x;
            });
            row.unshift(new Date(ob.timestamp).getTime());
            if (row.length === columns.length) {
                chartProps.data.addRow(row);
            }
            else {
                debug && console.log(`mismatched row length, not puttin onto data`);
            }
        });
        if (chartProps.data.getNumberOfRows() === 1) {
            chartProps = undefined;
            debug && console.log('undefining chart as only time series present');
        }
    }
    return chartProps;
};
export const FeatureAxisTOfeatureAxisStr = ({ featureId, axisId }) => {
    let res;
    const featurePart = FeatureIdRev[featureId];
    const axisPart = AxidIdRev[axisId];
    if (featurePart && axisPart) {
        res = `${featurePart} ${axisPart}`;
    }
    else {
        debug && console.log('Cant find ', { featureId, axisId }, { FeatureIds: FeatureIdRev, AxisIds: AxidIdRev });
    }
    return res;
};
